import { useQuery } from "@tanstack/react-query";
import { FolderKanban, Globe, KeyRound, XCircle } from "lucide-react";
import { relaySitesApi, keysApi, distributionsApi } from "@/api/client";
import { PageHeader } from "@/components/PageHeader";
import { StatCard } from "@/components/StatCard";

export function DashboardPage() {
  const sitesQ = useQuery({ queryKey: ["relay-sites"], queryFn: relaySitesApi.list });
  const keysQ = useQuery({ queryKey: ["keys", "count"], queryFn: () => keysApi.list({ page: 1, page_size: 1 }) });
  const tasksQ = useQuery({ queryKey: ["tasks", "count"], queryFn: () => distributionsApi.list({ page: 1, page_size: 1 }) });
  const failedQ = useQuery({
    queryKey: ["tasks", "count", "failed-or-unknown"],
    queryFn: () => distributionsApi.list({ status: ["failed", "unknown"], page: 1, page_size: 1 }),
  });

  const total = (q: { data?: { total?: number }; isLoading: boolean }) => (q.isLoading ? "…" : (q.data?.total ?? 0));

  const failed = failedQ.data?.total ?? 0;

  return (
    <div className="space-y-7">
      <PageHeader
        eyebrow="Overview"
        title="总览"
        description="词元供应与分发链路的实时资产视图。"
      />
      <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 xl:grid-cols-4">
        <StatCard label="上游 Key" value={total(keysQ)} note="上传统计" icon={KeyRound} tone="blue" />
        <StatCard label="中转站" value={total(sitesQ)} note="relay 站点" icon={Globe} tone="green" />
        <StatCard label="分发任务" value={total(tasksQ)} note="历史任务" icon={FolderKanban} tone="orange" />
        <StatCard
          label="失败任务"
          value={failed}
          note={failed > 0 ? "需关注" : "最近无失败"}
          icon={XCircle}
          tone="purple"
          highlight={failed > 0}
        />
      </div>
    </div>
  );
}